// Sep 13 2026 — participation-day contract module.
//
// Single source of truth for the admin participation-day dropdown
// options, canonical dated labels, and the display→enum parse
// helper. `AdminDashboard.jsx` re-imports these values so the
// isolated Jest fixture in `src/__tests__/participationDayDropdown.test.js`
// can exercise them without loading the entire dashboard module
// tree (which pulls in `react-router-dom`, `framer-motion`,
// `axios`, etc. that a jsdom unit test does not need).
//
// Owner directive D-1: this extraction is a DRY hygiene move; it
// preserves every visible behavior exactly (same option list, same
// enum ids, same "label — date" separator character).
//
// Keys MUST match /app/backend/server.py PARTICIPATION_DAYS.

export const PARTICIPATION_DAYS = [
  { id: "day1",      label: "Day 1",                            date: "Thursday, December 10, 2026" },
  { id: "day2",      label: "Day 2",                            date: "Friday, December 11, 2026" },
  { id: "day3",      label: "Day 3",                            date: "Saturday, December 12, 2026" },
  // Feb 26, 2026 — owner-added combined Day-1-and-Day-3 variant for
  // Indian Motorcycles. Represents Dec 10 AND Dec 12 together,
  // intentionally excluding Dec 11. The English label uses an
  // ampersand and a plain hyphen (NOT an em-dash) by owner directive;
  // the Arabic label uses an em-dash and keeps the brand name
  // "Indian" in Latin letters.
  { id: "day1_day3", label: "Day 1 & Day 3 - Indian Motorcycles", date: "December 10 & 12, 2026" },
  { id: "indoor",    label: "Three-Day Indoor Display",         date: "December 10\u201312, 2026" },
  { id: "outdoor",   label: "Full Event Outdoor Display Pass",  date: "December 10\u201312, 2026" },
];

// Canonical "label — date" display strings. Em-dash (U+2014) between
// name and date, en-dash (U+2013) inside the date range — matches
// the approval-email template.
export const PARTICIPATION_DAY_FULL_LABELS = Object.fromEntries(
  PARTICIPATION_DAYS.map(d => [d.id, `${d.label} \u2014 ${d.date}`])
);

export const PARTICIPATION_DAY_FULL_LABEL_LIST = PARTICIPATION_DAYS.map(
  d => PARTICIPATION_DAY_FULL_LABELS[d.id]
);

// Reverse-mapping helper: full "label — date" display string → enum
// id (`outdoor`, `day1`, …). Empty string when the input is unknown.
export const parseParticipationDayLabel = (full) => {
  const hit = PARTICIPATION_DAYS.find(
    (d) => PARTICIPATION_DAY_FULL_LABELS[d.id] === full
  );
  return hit ? hit.id : "";
};
